const MailRuIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6Zm2.4 1.2 6.6 4.95 6.6-4.95V6.6L12 11.55 5.4 6.6v.6Z"
        fill="white"
      />
    </svg>
  );
};

export default MailRuIcon;
